module.exports = __webpack_public_path__ + "img/icon-question-rating-skin-like.c64acb6b.svg";